import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Customer.css';

interface Claim {
  id: number;
  warranty_id: number;
  product_image: string;
  video_proof: string;
  upi_id: string;
  upi_qr: string;
  status: string;
  admin_notes: string;
  created_at: string;
  serial_number: string;
}

const ClaimStatus: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [claim, setClaim] = useState<Claim | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClaim();
  }, [id]);

  const fetchClaim = async () => {
    try {
      const response = await axios.get(`/api/claim/${id}`);
      setClaim(response.data.claim);
    } catch (error) {
      console.error('Failed to fetch claim:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="loading">Loading...</div>
      </>
    );
  }

  if (!claim) {
    return (
      <>
        <Navbar />
        <div className="container">
          <div className="card">
            <p>Claim not found</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container">
        <h1 className="page-title">📊 Claim Status</h1>
        <div className="card">
          <div className="claim-header">
            <h3>Claim #{claim.id}</h3>
            <span className={`status-badge status-${claim.status}`}>
              {claim.status.toUpperCase()}
            </span>
          </div>
          <div className="claim-info">
            <p><strong>Serial Number:</strong> {claim.serial_number}</p>
            <p><strong>Submitted:</strong> {new Date(claim.created_at).toLocaleString()}</p>
            {claim.admin_notes && (
              <p><strong>Admin Notes:</strong> {claim.admin_notes}</p>
            )}
          </div>
          <div className="claim-media">
            {claim.product_image && (
              <div>
                <h4>Product Image</h4>
                <img
                  src={claim.product_image}
                  alt="Product"
                  className="claim-image"
                />
              </div>
            )}
            {claim.video_proof && (
              <div>
                <h4>Video Proof</h4>
                <video
                  src={claim.video_proof}
                  controls
                  className="claim-video"
                />
              </div>
            )}
            {claim.upi_qr && (
              <div>
                <h4>UPI QR Code</h4>
                <img
                  src={claim.upi_qr}
                  alt="UPI QR"
                  className="claim-image"
                />
              </div>
            )}
            {claim.upi_id && (
              <p><strong>UPI ID:</strong> {claim.upi_id}</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ClaimStatus;

